import React from "react";

import createStore from "EmployeeApplication/createStore";
import { adminEmployeeParam } from "EmployeeApplication/urls";
import { Provider } from "react-redux";

import PartnerContext from "Common/PartnerContext";
import PartnerProvider from "Common/PartnerProvider";
import ThemeInstaller from "Common/ThemeInstaller";

import EmployeeRenewalApplication from "./EmployeeRenewalApplication";

import type { State, Action } from "EmployeeApplication/createStore";
import type { Store } from "redux";

class EmployeeRenewalApplicationApp extends React.Component {
  store: Store<State, Action>;

  constructor(props) {
    super(props);
    this.store = createStore({
      employeeHashId: props.match.params[adminEmployeeParam],
    });
  }

  render() {
    return (
      <Provider store={this.store}>
        <PartnerProvider>
          <PartnerContext.Consumer>
            {({ color }) => (
              <>
                <EmployeeRenewalApplication match={this.props.match} />
                <ThemeInstaller color={color} />
              </>
            )}
          </PartnerContext.Consumer>
        </PartnerProvider>
      </Provider>
    );
  }
}

export default EmployeeRenewalApplicationApp;
